import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const getProcessing = (id) => {
  return axios.get(API + `processing/process/${id}/`,{headers: authHeader(),});
};
const cancelProcessing = (id) => {
  return axios.delete(API + `processing/cancel-process/${id}/`,{headers: authHeader(),});
};
const rescheduleProcessing = (id, next_run_date, interval_type) => {
  return axios.post(API + `processing/reschedule-process/${id}/`, { next_run_date, interval_type }, {headers: authHeader(),});
};
const GetProcessingService = {
    getProcessing,
    cancelProcessing,
    rescheduleProcessing
  };
  export default GetProcessingService;